<template>
  <div>
    <div class="user_body">
      <span class="title">积分明细</span>
      <div class="search_top">
        <div class="tabs">
          <span class="tab_nselect">我的积分：</span> 
          <span class="tab_select">{{user.score}}</span> 
        </div>
        <!-- <el-input placeholder="请输入内容" suffix-icon="el-icon-search" v-model="input1" class="input"></el-input> -->
      </div>

      <el-table
        ref="multipleTable"
        :data="tableData"
        :header-cell-style="tableHeaderStyle"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="title" label="获得路径" ></el-table-column>
        <el-table-column prop="name" label="积分" >
              <template slot-scope="scope">
            <span style="color:#3C9C8F;font-weight:800;">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="afters" label="变动后" ></el-table-column>
        <el-table-column prop="check" label="时间" ></el-table-column> 
      </el-table>
      <div class="footer">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage1"
        :page-size="5"
        layout="total, prev, pager, next"
        :total="tableData.length"
        small
      ></el-pagination>
      </div>
      
    </div>
  </div>
</template>

<script>
import bus from "@/components/eventBus.js";
import { mapGetters } from 'vuex';
export default {
  name: "SuggestionsView",
  data() {
    return {
      tableData: [
      
      ],
      loading: false,
      multipleSelection: [],
      currentPage1: 1,
      total:10,
    };
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted() {
    this.getScoreLog()
  },
  methods: {
    getScoreLog(){
      this.loading = true
      this.$api.getScoreLog({
        page: this.currentPage1,
        current: 0
      }).then(res => {
        console.log(res)
        if(res.code == 1){
          this.tableData = res.data.list.map(item => ({
            title: item.remarks,
            name: item.moneyText,
            afters: item.afters,
            check: item.createtime
          }))
          this.total = res.data.total
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
      })
    },
    // 设置表头的颜色
    tableHeaderStyle({ row, column, rowIndex, columnIndex }) {
      return "background-color: #f9f9f9; color:#333333;"; //
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage1 = val;
      this.getScoreLog()
    }
  }
};
</script> 

<style lang="less"  scoped>
.user_body {
  background: #ffffff;
  padding: 25px;
  box-sizing: border-box;
}
.title {
  color: #666666;
  font-size: 16px;
}
.search_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  box-sizing: border-box;
}
.tabs { 
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
}
.input {
  width: 200px;
}
.tab_select {
  color: #3c9c8f;
  font-size: 16px;
  font-weight: 800;
}
.tab_nselect {
  color: #333333;
  font-size: 16px;
}
.s_line {
  margin-left: 10px;
  margin-right: 10px;
  size: 16px;
  color: #999999;
}
</style>
<style>
.custom-class {
  color: red;
  background: red !important;
}
::v-deep .custom-class {
  background-color: #f0f9eb; /* 设置为浅绿色 */
}
.el-table {
  border-bottom: 1px solid #ebeef5;
  background: #111111;
  width: 100%;
}
.footer{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
</style>


